import { map as rxjsmap } from 'rxjs';

import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

import {
  EmployeeHoliday,
  EmployeeLeave,
  EmployeeLeaveAvailability
} from '../models';
import { BaseServices } from './../../kuba.services';

import { HttpClient } from '@angular/common/http';

@Injectable()
export class EmployeeLeaveService {
  ses: string;

  constructor(private http: HttpClient) {}
  getAllByBusinessId(businessId: number, getYear: any) {
    // remesh
    return this.http
      .get(
        environment.BASE_URL + '/employeeleaves/' + businessId + '/' + getYear
      )
      .pipe(rxjsmap((result: any) => result));
  }
  getEmployeeLeavesByEmployeeId(id: number) {
    return this.http
      .get(environment.BASE_URL + '/employeeleavesbyemployeeid/' + id)
      .pipe(rxjsmap(result => result));
  }
  getAvailableLeaves(empId: number, bid: number, year: number) {
    return this.http
      .get(
        environment.BASE_URL +
          '/employeeavailableleaves?EmployeeId=' +
          empId +
          '&BusinessId=' +
          bid +
          '&Year=' +
          year
      )
      .pipe(rxjsmap(result => result));
  }

  getEmployeeLeaveByLeaveId(id: number) {
    return this.http
      .get(environment.BASE_URL + '/employeeleavebyleaveid/' + id)
      .pipe(rxjsmap((result: any) => result));
  }

  exportEmployeeLeaveToExcel(
    langId: number,
    id: number,
    startDate: string,
    endDate: string
  ) {
    const url = `${environment.BASE_URL}/employeeleave/exportToExcel/langId/${langId}/businessId/${id}/startDate/${encodeURIComponent(startDate)}/endDate/${encodeURIComponent(endDate)}`;
    return this.http.post(url, null, { responseType: 'blob' });
  }

  // bind emp dropdown
  getEmpByName(id: number) {
    return this.http
      .get(environment.BASE_URL + '/employees/' + id)
      .pipe(rxjsmap(employees => employees));
  }

  add(employee: EmployeeLeave) {
    return this.http
      .post(environment.BASE_URL + '/employeeleave', JSON.stringify(employee))
      .pipe(rxjsmap(result => result));
  }

  update(employee: EmployeeLeave) {
    return this.http
      .put(environment.BASE_URL + '/employeeleave/' + employee.Id, employee)
      .pipe(rxjsmap(result => result));
  }

  deleteLeave(id: number) {
    return this.http
      .delete(environment.BASE_URL + '/employeeleave/' + id)
      .pipe(rxjsmap(leave => leave));
  }

  deleteHoliday(id: number) {
    return this.http
      .delete(environment.BASE_URL + '/employeeHoliday/' + id)
      .pipe(
        rxjsmap((response: any) => {
          return response;
        })
      );
  }
  // get approval person list
  getAllApprovedPerson() {
    return this.http
      .get(
        environment.BASE_URL +
          '/approval-persons-business/' +
          BaseServices.BusinessId
      )
      .pipe(rxjsmap((result: any) => result));
  }
  // bing grid holidaty type
  getAllLeaveAllocation(bid: number, year: number) {
    return this.http
      .get(environment.BASE_URL + '/leaveavailability/' + bid + '/' + year)
      .pipe(rxjsmap(result => result));
  }
  getAllHolidays(bid: number) {
    return this.http
      .get<EmployeeHoliday[]>(environment.BASE_URL + '/employeeholidays/' + bid)
      .pipe(rxjsmap(result => result));
  }

  saveLeaveAllocation(leave: EmployeeLeaveAvailability[]) {
    return this.http
      .post(environment.BASE_URL + '/employeeallocatedleave', leave)
      .pipe(rxjsmap(result => result));
  }
  // update employee type
  updateHoliday(existingCategory: EmployeeHoliday) {
    return this.http
      .put(
        environment.BASE_URL + '/employeeholiday/' + existingCategory.Id,
        existingCategory
      )
      .pipe(rxjsmap(result => result));
  }
  // adding employee Type
  createHoliday(newCategory: EmployeeHoliday) {
    return this.http
      .post(
        environment.BASE_URL + '/employeeholiday',
        JSON.stringify(newCategory)
      )
      .pipe(rxjsmap(result => result));
  }
  saveDayPilotLeaves(saveDayPilotLeaves: any, editedBy: number) {
    return this.http
      .post(
        environment.BASE_URL +
          '/employeeleave/savedaypilotleaves/' +
          editedBy +
          '/' +
          BaseServices.userLanguageId,
        JSON.stringify(saveDayPilotLeaves)
      )
      .pipe(rxjsmap(result => result));
  }
}
